<div class="form-container">
    <h2>Crear Encuesta</h2>
    <form [formGroup]="encuestaForm" (ngSubmit)="onSubmit()">
      <!-- Campo Nombre -->
      <div class="form-group">
        <label for="Nombre">Nombre</label>
        <input
          id="Nombre"
          type="text"
          formControlName="Nombre"
          placeholder="Ingrese el nombre de la encuesta"
        />
        <small *ngIf="controls['Nombre'].invalid && controls['Nombre'].touched" class="error">
          El nombre es obligatorio.
        </small>
      </div>
  
      <!-- Campo Descripción -->
      <div class="form-group">
        <label for="Descripcion">Descripción</label>
        <textarea
          id="Descripcion"
          formControlName="Descripcion"
          placeholder="Ingrese la descripción de la encuesta"
        ></textarea>
        <small *ngIf="controls['Descripcion'].invalid && controls['Descripcion'].touched" class="error">
          La descripción es obligatoria.
        </small>
      </div>
  
      <!-- Campo Activa -->
      <div class="form-group">
        <label for="Activa">Encuesta Activa</label>
        <input
          id="Activa"
          type="checkbox"
          formControlName="Activa"
        />
      </div>
  
      <!-- Campo Agregar Encuestados -->
      <div class="form-group">
        <label for="AgregarEncuestados">Agregar Encuestados</label>
        <input
          id="AgregarEncuestados"
          type="checkbox"
          formControlName="AgregarEncuestados"
        />
        <small class="info">
          Este campo permite al usuario agregar registros y no solo diligenciar los registros precargados.
        </small>
      </div>
  
      <!-- Botón Crear Encuesta -->
      <div class="form-group" style="display: flex; gap: 10px;">
        <button *ngIf="IdEncuesta!=null" type="submit" [disabled]="encuestaForm.invalid">Guardar Encuesta</button>
        <button *ngIf="IdEncuesta==null" type="submit" [disabled]="encuestaForm.invalid">Crear Encuesta</button>
        <button type="button" (click)="cancelarcreacion()">Cancelar</button>
      </div>
    </form>
  </div>
  